export default __webpack_public_path__ + "static/media/talking-2.a78c1206.svg";